/* eslint-disable import/prefer-default-export */
import { formatDate } from '@/utils';
export function createModelName(reportType, valueType, value) {
    return `${reportType} - ${formatDate(Date.now())} - ${valueType}: ${value}`;
}
